// src/components/PlayerPhoto.jsx

import React, { useState } from 'react';
import { getPhotoUrl } from '../utils/photoHelper';
import BustSilhouette from './BustSilhouette';

export default function PlayerPhoto({ player, className = '', style = {} }) {
  const [failed, setFailed] = useState(false);

  const src = !failed ? getPhotoUrl(player.espn_id, player.espn_type) : null;

  // No ID or image failed — show the shared bust placeholder (same component
  // Sr. uses during play, so the two games are identical by construction).
  if (!src) {
    return <BustSilhouette className={className} style={style} />;
  }

  return (
   <img
  src={src}
  alt={player.player || 'Player photo'}
  className={className}
  decoding="async"
  width="200"
  height="145"
  style={{
    ...style,
    width: '100%',
    maxHeight: '145px',
    objectFit: 'contain',
    objectPosition: 'center',
    background: '#111b30',
  }}
  onError={() => setFailed(true)}
/>
  );
}